module.exports = __webpack_public_path__ + "static/img/102131.c14c5c0c.png";